import Vue from 'vue';

class UserOnboardingPerPage {

    pageName = {
        dashboard: 'dashboard',
        campaign: 'campaign',
    }

    perPage = {
        dashboard: {
            obd2_yes_time: 'obd2_yes_time',
            obd2_no_time: 'obd2_no_time',
            obd2_close_time: 'obd2_close_time',
            obd2_exit_time: 'obd2_exit_time',
            obd2_stop_at: 'obd2_stop_at',
            obd2_like_time: 'obd2_like_time',
            obd2_dislike_time: 'obd2_dislike_time',
        },

        campaign: {
            obd1_yes_time: 'obd1_yes_time',
            obd1_no_time: 'obd1_no_time',
            obd1_close_time: 'obd1_close_time',
            obd1_exit_time: 'obd1_exit_time',
            obd1_stop_at: 'obd1_stop_at',
            obd1_like_time: 'obd1_like_time',
            obd1_dislike_time: 'obd1_dislike_time'
        }
    }

    async syncUserOnboardingToAirTable(params) {
        try {
            const res = await Vue.axios.post('/user-onboarding-per-page/sync-data-to-airtable', params);

            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }   
}

const userOnboardingPerPage = new UserOnboardingPerPage();

export default userOnboardingPerPage;


// WEBPACK FOOTER //
// ./src/core/services/userOnboardingPerPage.js